import { BOT, PERMISSION_LEVELS } from '../../const';
import { dispatch } from '../../dispatcher';
import { ActionTypes } from '../../constants/MogamboConstants';

import * as Api from '../../api';
import { userHasPermission, permissionErrorAlert } from '../_utils';

export function getSynonyms(sentence) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('get synonyms');
  }
  Api.getSynonyms(sentence);
}

export function getMeanings(word, callback) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('get word meanings');
  }
  Api.getMeanings(word, callback);
}

export function updateSynonyms(updatedCluster) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('update synonyms');
  }
  dispatch(ActionTypes.UPDATE_SYNONYMS, { data: updatedCluster });
}
